import { FEATURE_FLAG_KEYS } from '@alpha-core/feature-flags/feature-flag.constants';
import { FooterComponent, ProjectService } from '@alpha-core/platform-ui';
import { DevModeBannerComponent } from '@alpha-core/platform-ui/components/dev-mode-banner.component';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { FeatureFlagsService } from '@neutrinos/ngx-feature-flags';
import { MenuItem } from 'primeng/api';
import { AdminFilterService } from '../../services/admin-filter.service';
import { PrimeNGModules } from '../../shared/alpha-shared.module';
import { BreadCrumbComponent } from '../bread-crumb/bread-crumb.component';
import { DashboardService } from '../dashboard/dashboard.service';
import { MainSidenavComponent } from './main-sidenav/main-sidenav.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
@Component({
    selector: 'app-base-layout',
    standalone: true,
    imports: [
        FormsModule,
        ...PrimeNGModules,
        MainSidenavComponent,
        ToolbarComponent,
        FooterComponent,
        BreadCrumbComponent,
        DevModeBannerComponent,
    ],
    templateUrl: './base-layout.component.html',
    styleUrl: './base-layout.component.css',
})
export class BaseLayoutComponent implements OnInit {
    private router = inject(Router);
    private activeRoute = inject(ActivatedRoute);
    private projectService = inject(ProjectService);
    private dashboardService = inject(DashboardService);
    private adminFilterService = inject(AdminFilterService);
    private featureFlagsService = inject(FeatureFlagsService);

    private destroyDef = inject(DestroyRef);
    showMenuComponent = false;
    defaultItems: MenuItem[] = [
        {
            label: 'default-cm-inbox',
            routerLink: '/home/cases',
            queryParams: { projectId: this.projectService.fetchCurrentProject()?.projectId },
        },
        {
            label: 'default-cm-reassign',
        },
    ];
    items: MenuItem[] = this.defaultItems;

    ngOnInit(): void {
        const project = this.projectService.fetchCurrentProject();
        const projectId = project?.projectId;
        if (!projectId) {
            return;
        }

        this.dashboardService
            .getDashboardStatus(projectId)
            .then((res) => {
                if (res?.enabled) {
                    this.categorizedPages[0].pages.push({
                        title: 'default-cm-dashboard',
                        route: '/home/dashboard',
                        activeIcon: 'assets/icons/dashboard.svg',
                        nonActiveIcon: 'assets/icons/dashboard-colorless.svg',
                        menuId: 'dashboard',
                    });
                }
            })
            .finally(() => {
                this.categorizedPages[0].pages.map((x: any, index: number) => {
                    this.updateIndexNumberFromUrl(this.activeRoute.firstChild?.snapshot.data['menuId']);
                });
            });

        this.router.events.pipe(takeUntilDestroyed(this.destroyDef)).subscribe((event) => {
            if (event instanceof NavigationEnd && this.activeRoute.firstChild?.snapshot?.data) {
                this.updateIndexNumberFromUrl(this.activeRoute.firstChild.snapshot.data['menuId']);
                const isReassignmentRoute = this.isReassignmentRoute();
                if (isReassignmentRoute) {
                    this.showMenuComponent = true;
                    this.items = this.defaultItems;
                } else this.showMenuComponent = false;
            }
        });

        this.addAdminFilterManagementPageIfFeatureEnabled();
    }

    private addAdminFilterManagementPageIfFeatureEnabled(): void {
        const adminFilterFeatureEnabled = this.featureFlagsService.isFeatureEnabled(FEATURE_FLAG_KEYS.ADMIN_FILTERS);
        if (adminFilterFeatureEnabled) {
            this.adminFilterService.breadcrumb$.pipe(takeUntilDestroyed(this.destroyDef)).subscribe((items) => {
                this.items = items;
                this.showMenuComponent = true;
            });
            this.categorizedPages[0].pages.push({
                title: 'default-admin-filters',
                route: '/home/custom-list',
                activeIcon: 'assets/icons/admin-filter.svg',
                nonActiveIcon: 'assets/icons/admin-filter-non-active.svg',
                menuId: 'custom-list',
            });
        }
    }

    private updateIndexNumberFromUrl(data: string): void {
        this.indexNumber = this.categorizedPages[0].pages.findIndex((page: any) => data === page.menuId);
    }

    private isReassignmentRoute(): boolean {
        return this.activeRoute.firstChild?.snapshot.routeConfig?.path?.split('/').includes('reassignment') || false;
    }

    private isCreateOrEditFilterRoute(): boolean {
        const { routeConfig } = this.activeRoute.firstChild?.snapshot || ({} as ActivatedRouteSnapshot);
        return routeConfig?.path?.split('/').includes('custom-list') || false;
    }

    indexNumber = 0;
    categorizedPages: any[] = [
        {
            category: null,
            pages: [
                {
                    title: 'default-cm-inbox',
                    route: '/home/cases',
                    activeIcon: 'assets/icons/inbox.svg',
                    nonActiveIcon: 'assets/icons/inbox-colorless.svg',
                    menuId: 'cases',
                },
                {
                    title: 'default-cm-users',
                    route: '/home/users/all-users',
                    activeIcon: 'assets/icons/users-active.svg',
                    nonActiveIcon: 'assets/icons/users-inactive.svg',
                    menuId: 'users',
                },
                {
                    title: 'default-cm-groups',
                    route: '/home/groups',
                    activeIcon: 'assets/icons/group-active.svg',
                    nonActiveIcon: 'assets/icons/group-inactive.svg',
                    menuId: 'groups',
                },
            ],
        },
    ];

    pageEmit(event: any) {
        const project = this.projectService.fetchCurrentProject();

        this.router.navigate([event.route], {
            queryParams: {
                projectId: project?.projectId,
            },
        });
    }
}
